module.exports = __webpack_public_path__ + "fonts/text-security-disc-compat.7c7d806.eot";